<script lang="ts">
	import { resolve } from '$app/paths';
</script>

<svelte:head>
	<title>Legal - Hessian</title>
	<meta
		name="description"
		content="Legal policies for Hessian, including the Terms of Service and Privacy Policy."
	/>
</svelte:head>

<h1 class="text-4xl font-semibold tracking-tighter sm:text-5xl">Legal</h1>
<p class="text-muted-foreground mt-4 text-base">
	The agreements and policies that govern your use of Hessian.
</p>

<div class="mt-10 grid gap-4 sm:grid-cols-2">
	<a
		href={resolve('/legal/terms')}
		class="border-border hover:border-primary group rounded-lg border p-6 transition-colors"
	>
		<h2 class="text-primary text-xl font-medium">Terms of Service</h2>
		<p class="text-muted-foreground mt-2 text-sm">
			The terms that apply when you use Hessian's products and services.
		</p>
	</a>

	<a
		href={resolve('/legal/privacy')}
		class="border-border hover:border-primary group rounded-lg border p-6 transition-colors"
	>
		<h2 class="text-primary text-xl font-medium">Privacy Policy</h2>
		<p class="text-muted-foreground mt-2 text-sm">
			How we collect, use, and protect the personal data we process.
		</p>
	</a>

	<a
		href={resolve('/legal/dpa')}
		class="border-border hover:border-primary group rounded-lg border p-6 transition-colors"
	>
		<h2 class="text-primary text-xl font-medium">Data Processing Addendum</h2>
		<p class="text-muted-foreground mt-2 text-sm">
			How we process personal data on behalf of our customers.
		</p>
	</a>

	<a
		href={resolve('/legal/subprocessors')}
		class="border-border hover:border-primary group rounded-lg border p-6 transition-colors"
	>
		<h2 class="text-primary text-xl font-medium">Subprocessors</h2>
		<p class="text-muted-foreground mt-2 text-sm">
			The third-party providers we engage to deliver the Hessian Service.
		</p>
	</a>
</div>
